import { render, staticRenderFns } from "./CombineLegForm.vue?vue&type=template&id=e69bcc66&scoped=true"
import script from "./CombineLegForm.vue?vue&type=script&lang=js"
export * from "./CombineLegForm.vue?vue&type=script&lang=js"
import style0 from "./CombineLegForm.vue?vue&type=style&index=0&id=e69bcc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69bcc66",
  null
  
)

export default component.exports